"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginateListAssistantMessages = void 0;
const Apiv2Client_1 = require("../Apiv2Client");
const ListAssistantMessagesCommand_1 = require("../commands/ListAssistantMessagesCommand");
const core_1 = require("@smithy/core");
exports.paginateListAssistantMessages = (0, core_1.createPaginator)(Apiv2Client_1.Apiv2Client, ListAssistantMessagesCommand_1.ListAssistantMessagesCommand, "nextToken", "nextToken", "pageSize");
